import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M12.2 0H2v8.703l1.2-1.2V1.2H11V5h3.8v11.8H8.491l-1.2 1.2H16V3.8L12.2 0zm0 3.8V1.697L14.303 3.8H12.2zm-.174 3.734a2.858 2.858 0 0 0-4.03 0v.001l-5.222 5.223a1.752 1.752 0 0 0 0 2.474c.341.342.79.512 1.237.512.448 0 .896-.17 1.238-.512l4.42-4.42-.849-.848-4.42 4.42a.553.553 0 0 1-.778 0 .552.552 0 0 1 0-.778l5.222-5.222a1.65 1.65 0 1 1 2.333 2.334L5.9 15.994a2.76 2.76 0 0 1-3.895 0 2.758 2.758 0 0 1 0-3.896l4.53-4.528-.849-.847-4.528 4.527a3.958 3.958 0 0 0 0 5.592c.771.771 1.783 1.156 2.796 1.156s2.025-.385 2.796-1.156l5.277-5.276a2.855 2.855 0 0 0-.001-4.032z" />
  </svg>
);

export default SvgComponent;
